import React from 'react';
import { TopBar } from '../../components/layout/TopBar';
import { Header } from '../../components/layout/Header';
import { Navigation } from '../../components/layout/Navigation';
import { MobileStickyBar } from '../../components/layout/MobileStickyBar';
import { Footer } from '../../components/layout/Footer';
import { useScreenInit } from '../../useScreenInit';
import { usePageTitle } from '../../hooks/usePageTitle';
import { MapPin, Phone, CheckCircle2, ShieldCheck, AlertTriangle, ArrowRight, Search, Wrench, ClipboardCheck, Trash2 } from 'lucide-react';
export function DominionValley() {
  usePageTitle('Dominion Valley Community | MidAtlantic Mailboxes');
  useScreenInit();
  return <div className="min-h-screen flex flex-col bg-brand-background" data-id="element-1246" data-mp="35o22srh4z4gm">
      <TopBar data-id="element-1247" data-mp="3tefzivao1rhj" />
      <Header data-id="element-1248" data-mp="3tdwdp3hwaiy8" />
      <Navigation data-id="element-1249" data-mp="3tdd90oh99r25" />

      <main className="flex-grow" data-id="element-1250" data-mp="3tcv4l4kfw6j5">
        {/* Hero */}
        <section className="bg-white border-b border-brand-border py-16 lg:py-24" data-id="element-1251" data-mp="20a6qlu4mq0o">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1252" data-mp="2amkj4t1n0105">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-1253" data-mp="2ancatss45el5">
              <div data-id="element-1254" data-mp="25oizo70atzo5">
                <span className="inline-flex items-center gap-2 py-1 px-3 rounded-full bg-brand-goldSoft text-brand-charcoal text-xs font-bold tracking-wide mb-4 uppercase border border-brand-gold/30" data-id="element-1255" data-mp="25p2jjt9iey4t">
                  <MapPin size={14} data-id="element-1256" data-mp="2fk2pqcs6m44z" /> Haymarket, VA · Community Service
                </span>
                <h1 className="text-4xl lg:text-5xl font-serif font-bold text-brand-charcoal mb-6 leading-tight" data-id="element-1257" data-mp="2tbhdewx1atid">
                  Regency at Dominion Valley Mailbox Services
                </h1>
                <p className="text-lg text-brand-muted leading-relaxed mb-6" data-id="element-1258" data-mp="33aq33dkv9lyx">
                  MidAtlantic Mailbox, Inc. proudly serves the Regency at
                  Dominion Valley community. We provide model identification,
                  repairs, replacement parts, and HOA-approved mailbox
                  installations for homeowners.
                </p>
                <div className="flex flex-col sm:flex-row gap-4" data-id="element-1259" data-mp="3415bjxa5qpm9">
                  <a href="tel:301-620-7585" className="bg-brand-maroon hover:bg-brand-maroonDark text-white px-6 py-3.5 rounded-md font-bold transition-colors shadow-sm flex items-center justify-center gap-2" data-id="element-1260" data-mp="38zgkm5smow3f">
                    <Phone size={18} data-id="element-1261" data-mp="3i1g20z7k226w" /> Call 301-620-7585
                  </a>
                  <a href="/3947.html" className="bg-white border border-brand-border hover:border-brand-maroon text-brand-charcoal px-6 py-3.5 rounded-md font-bold transition-colors shadow-sm flex items-center justify-center gap-2" data-id="element-1262" data-mp="3myg8vcc8b8z2">
                    View Our Services <ArrowRight size={16} data-id="element-1263" data-mp="4kqkqfo65kon" />
                  </a>
                </div>
              </div>
              <div className="relative" data-id="element-1264" data-mp="9m6505iivn5z">
                <div className="rounded-2xl overflow-hidden shadow-lg border border-brand-border" data-id="element-1265" data-mp="ej6b2gfdgpx3">
                  <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/Regency%20at%20Dominion%20Valley%20Community%20.png" alt="Regency at Dominion Valley community" className="w-full h-full object-cover" data-id="element-1266" data-mp="on38lrzahgmc" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* HOA Approved Model */}
        <section className="py-12 bg-brand-goldWash border-b border-brand-border" data-id="element-1267" data-mp="17d2q9tssvtfq">
          <div className="max-w-5xl mx-auto px-4" data-id="element-1268" data-mp="12g2o3tz2natw">
            <div className="bg-white rounded-2xl border border-brand-border shadow-sm p-8 flex flex-col md:flex-row items-center gap-8 text-center md:text-left" data-id="element-1269" data-mp="xnsyyg5s6eso">
              <div className="w-20 h-20 rounded-full bg-brand-goldSoft text-brand-maroon flex items-center justify-center shrink-0" data-id="element-1270" data-mp="tm7hehiaxcc5">
                <ShieldCheck size={40} data-id="element-1271" data-mp="1ldvoopm838o4" />
              </div>
              <div data-id="element-1272" data-mp="1lcc78votyrkr">
                <span className="text-brand-maroon font-bold tracking-wider uppercase text-xs mb-2 block" data-id="element-1273" data-mp="1lbsnd9fmdt43">
                  HOA Approved Mailbox System
                </span>
                <h2 className="text-2xl lg:text-3xl font-serif font-bold text-brand-charcoal mb-2" data-id="element-1274" data-mp="1aw09mmtgnjfl">
                  Imperial Model C1-6425-7 in Black
                </h2>
                <p className="text-brand-muted" data-id="element-1275" data-mp="10xkf09v85s1c">
                  This is the official mailbox system approved by the Dominion
                  Valley HOA, provided and serviced by MidAtlantic Mailbox, Inc.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Homeowners Notice */}
        <section className="py-12 bg-white border-b border-brand-border" data-id="element-1276" data-mp="1ftjpfr5t449n">
          <div className="max-w-5xl mx-auto px-4" data-id="element-1277" data-mp="1ju2fpgs1x29q">
            <div className="bg-brand-maroon/5 border border-brand-maroon/20 rounded-xl p-6 lg:p-8 flex flex-col md:flex-row gap-6 items-start" data-id="element-1278" data-mp="27kzju7dluvaf">
              <div className="w-12 h-12 rounded-full bg-brand-maroon/10 text-brand-maroon flex items-center justify-center shrink-0" data-id="element-1279" data-mp="2cchl6wjjixvx">
                <AlertTriangle size={24} data-id="element-1280" data-mp="umhnk0v0y4k" />
              </div>
              <div data-id="element-1281" data-mp="3s28oflivlgpn">
                <h2 className="text-xl font-bold text-brand-maroon mb-3" data-id="element-1282" data-mp="3s2qjietsxovz">
                  Homeowners Notice
                </h2>
                <div className="space-y-3 text-brand-charcoal/80 leading-relaxed text-sm" data-id="element-1283" data-mp="5nfhbthh1g9s">
                  <p data-id="element-1284" data-mp="5ps1mdapc2q0">
                    If you have questions about your mailbox, need a repair or a
                    replacement part, or are looking to update your mailbox
                    system, please call{' '}
                    <a href="tel:301-620-7585" className="font-semibold text-brand-maroon hover:underline" data-id="element-1285" data-mp="3o1y93i971dy4">
                      301-620-7585
                    </a>
                    .
                  </p>
                  <p data-id="element-1286" data-mp="yc3asccdjbyf">
                    Your current model required by the Dominion Valley HOA is
                    not listed for sale online, as there are many models with a
                    similar design and a different mounting mechanism.
                  </p>
                  <p className="font-semibold text-brand-charcoal" data-id="element-1287" data-mp="1acjgob7d3trz">
                    Please note: as of 2021–2022, homeowners are instructed to
                    update their old mailbox model to the correct mailbox model
                    if they are in need of a repair or a replacement.
                  </p>
                  <p data-id="element-1288" data-mp="mmyvrmrnemg2">
                    Thank you for letting MidAtlantic Mailbox, Inc. serve you!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Bracket Comparison */}
        <section className="py-16 bg-brand-background border-b border-brand-border" data-id="element-1289" data-mp="11er95t7vtqf5">
          <div className="max-w-5xl mx-auto px-4" data-id="element-1290" data-mp="3z3ngiet20uc">
            <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-1291" data-mp="3w7nypnb743s">
              <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-1292" data-mp="8w3titbnn3lg">
                The Community Is Transferring Models
              </h2>
              <p className="text-brand-muted leading-relaxed" data-id="element-1293" data-mp="2i6cmpjqkfmz4">
                Below is a comparison of the old bracket mounting mechanism with
                the new bracket model. If you need a replacement mailbox
                bracket, call your mailbox experts at{' '}
                <a href="tel:301-620-7585" className="text-brand-maroon font-semibold hover:underline" data-id="element-1294" data-mp="289zyh1dsi1br">
                  301-620-7585
                </a>{' '}
                to ensure you have the correct model — the posts themselves are
                drilled to accommodate a certain mounting style.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1295" data-mp="1pfb418nnz9au">
              <div className="bg-white rounded-xl border border-brand-border shadow-sm overflow-hidden" data-id="element-1296" data-mp="1kgzu6xxdcysm">
                <div className="aspect-video bg-brand-goldWash flex items-center justify-center p-6" data-id="element-1297" data-mp="1fkj8sbhk0yj8">
                  <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/Large%20scroll%20Old%20Bracket.png" alt="Old large scroll bracket mounting mechanism" className="max-h-full object-contain" data-id="element-1298" data-mp="34dx96ppuds9x" />
                </div>
                <div className="p-5 text-center" data-id="element-1299" data-mp="2kpg08cp21wty">
                  <span className="text-xs font-bold uppercase tracking-wide text-brand-muted" data-id="element-1300" data-mp="2knv8euu4krzs">
                    Previous Model
                  </span>
                  <h3 className="font-bold text-brand-charcoal text-lg mt-1" data-id="element-1301" data-mp="2bp02ljuztjx0">
                    Large Scroll (Old Bracket)
                  </h3>
                </div>
              </div>
              <div className="bg-white rounded-xl border border-brand-maroon/30 shadow-sm overflow-hidden ring-1 ring-brand-maroon/10" data-id="element-1302" data-mp="21qk7l5suhqi8">
                <div className="aspect-video bg-brand-goldWash flex items-center justify-center p-6" data-id="element-1303" data-mp="26oltrzlki5xx">
                  <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/Y%20Bracket.png" alt="New Y bracket mounting mechanism" className="max-h-full object-contain" data-id="element-1304" data-mp="1n4wrbvprj64n" />
                </div>
                <div className="p-5 text-center" data-id="element-1305" data-mp="1s1dcqi5kv6e1">
                  <span className="text-xs font-bold uppercase tracking-wide text-brand-maroon" data-id="element-1306" data-mp="262hg72sj24p9">
                    Current Model
                  </span>
                  <h3 className="font-bold text-brand-charcoal text-lg mt-1" data-id="element-1307" data-mp="220vucry0mg2x">
                    Y Bracket (New Bracket)
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Service Callouts */}
        <section className="py-16 bg-white border-b border-brand-border" data-id="element-1308" data-mp="2prrt690w2bjo">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1309" data-mp="2krvp69s6yk44">
            <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-1310" data-mp="2ktgjpzeia31z">
              <span className="text-brand-maroon font-bold tracking-wider uppercase text-xs mb-2 block" data-id="element-1311" data-mp="3vbvidrr5617u">
                Your Mailbox, Our Mission
              </span>
              <h2 className="text-3xl font-serif font-bold text-brand-charcoal" data-id="element-1312" data-mp="3llsegwihf2uq">
                Your Mailbox Experts Are Here to Help
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6" data-id="element-1313" data-mp="3hm1narp1mkpo">
              {[{
              icon: Search,
              label: 'Model Identification'
            }, {
              icon: AlertTriangle,
              label: 'Damaged Mailbox Diagnostic'
            }, {
              icon: ClipboardCheck,
              label: 'Free Estimating Service'
            }, {
              icon: Wrench,
              label: 'Installation per USPS Guidelines'
            }, {
              icon: Trash2,
              label: 'Removal & Disposal of Old Mailbox'
            }].map(({
              icon: Icon,
              label
            }) => <div key={label} className="bg-brand-background p-6 rounded-xl border border-brand-border flex flex-col items-center text-center" data-id="element-1314" data-mp="19ctuxu350bgf">
                  <div className="w-12 h-12 rounded-full bg-brand-goldSoft text-brand-maroon flex items-center justify-center mb-4" data-id="element-1315" data-mp="1i66v9h3j6fcj">
                    <Icon size={22} data-id="element-1316" data-mp="1s33a04k0vxpj" />
                  </div>
                  <p className="font-semibold text-brand-charcoal text-sm" data-id="element-1317" data-mp="1s18kecxt3hf4">
                    {label}
                  </p>
                </div>)}
            </div>
          </div>
        </section>

        {/* About Community & Us */}
        <section className="py-16 lg:py-24 bg-brand-background border-b border-brand-border" data-id="element-1318" data-mp="2on8xqrwpd0l">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1319" data-mp="6pguidhvmfqb">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-1320" data-mp="6q0fk32tpk8k">
              <div className="bg-white rounded-2xl border border-brand-border shadow-sm p-8" data-id="element-1321" data-mp="1a1pbwj4ly1gc">
                <h2 className="text-2xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-1322" data-mp="152csk8cy3cii">
                  About the Community
                </h2>
                <p className="text-brand-muted leading-relaxed mb-4" data-id="element-1323" data-mp="1iz82e310t7zm">
                  Regency at Dominion Valley is a 55-and-over active adult
                  community in Haymarket, VA. Within the community, MidAtlantic
                  Mailbox, Inc. provides service for the mailboxes of
                  single-family homes and homeowners.
                </p>
                <p className="text-brand-muted leading-relaxed" data-id="element-1324" data-mp="22o0d9w01g6e7">
                  After development, the HOA reached out to our family-owned &
                  operated company in 2017, and we have been taking care of your
                  mailboxes ever since!
                </p>
              </div>
              <div className="bg-white rounded-2xl border border-brand-border shadow-sm p-8" data-id="element-1325" data-mp="26shubnf0k5la">
                <h2 className="text-2xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-1326" data-mp="2qe065ectg3q9">
                  About Us
                </h2>
                <p className="text-brand-muted leading-relaxed mb-6" data-id="element-1327" data-mp="2v9fjm56wvxm5">
                  Our matriarch, Anne Ingram, launched this woman-owned &
                  operated company in 2003. Over the next 22 years, she earned
                  the reputation in the Mid-Atlantic Region as the "Mailbox
                  Lady," and now she's looking to pass the torch to her
                  daughters. In typical start-up fashion, her now-booming
                  business began in her garage with a determination to make her
                  mark on the mailbox industry and help the community navigate a
                  confusing sector.
                </p>
                <div className="flex gap-4" data-id="element-1328" data-mp="1ooo0m6c2yhrd">
                  <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/woman%20owned%20badge.png" alt="Woman Owned Business" className="h-14 object-contain" data-id="element-1329" data-mp="1tmg3fve9joac" />
                  <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/family%20owned%20badge.png" alt="Family Owned Business" className="h-14 object-contain" data-id="element-1330" data-mp="1goqct9t6nrmt" />
                </div>
                <a href="/7.html" className="inline-flex items-center mt-6 text-brand-maroon font-semibold hover:text-brand-maroonDark transition-colors" data-id="element-1331" data-mp="12sw7f0rmbkeg">
                  Learn more about us <ArrowRight size={16} className="ml-1" data-id="element-1332" data-mp="ovzix5yz2f0q" />
                </a>
              </div>
            </div>

            {/* Trust strip */}
            <div className="mt-10 bg-white rounded-2xl border border-brand-border shadow-sm p-6" data-id="element-1333" data-mp="2naasfgt9egm0">
              <div className="grid grid-cols-2 md:grid-cols-5 gap-4 text-center" data-id="element-1334" data-mp="2jaa2p00pmizn">
                {['First Impressions Start at the Curb', 'Top-Rated Manufacturers', 'Family Owned & Operated', '22 Years of Trusted Service', 'Expert Industry Knowledge'].map(item => <div key={item} className="flex flex-col items-center gap-2" data-id="element-1335" data-mp="irumxn616u7c">
                    <CheckCircle2 size={20} className="text-brand-maroon" data-id="element-1336" data-mp="3i9azq4akq61g" />
                    <p className="text-xs font-semibold text-brand-charcoal leading-snug" data-id="element-1337" data-mp="3n72oipfx9c1f">
                      {item}
                    </p>
                  </div>)}
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 lg:py-20 bg-brand-charcoal text-center" data-id="element-1338" data-mp="a4vf3iy486">
          <div className="max-w-3xl mx-auto px-4" data-id="element-1339" data-mp="16i747on623al">
            <h2 className="text-3xl font-serif font-bold text-white mb-4" data-id="element-1340" data-mp="1bha6j1brhvev">
              Need a Repair or Replacement?
            </h2>
            <p className="text-gray-300 mb-8" data-id="element-1341" data-mp="37jn4bbou4o19">
              Call your Dominion Valley mailbox experts to confirm the correct
              HOA-approved model, brackets, and mounting style before you order.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1342" data-mp="3hh1g2xztcon8">
              <a href="tel:301-620-7585" className="bg-brand-gold hover:bg-brand-gold/90 text-brand-charcoal px-8 py-3.5 rounded-md font-bold transition-colors shadow-sm w-full sm:w-auto flex items-center justify-center gap-2" data-id="element-1343" data-mp="3cku70wc4ex12">
                <Phone size={18} data-id="element-1344" data-mp="2yl1mxjv3nf22" /> Call 301-620-7585
              </a>
              <a href="/5.html" className="bg-transparent border-2 border-white hover:bg-white hover:text-brand-charcoal text-white px-8 py-3.5 rounded-md font-bold transition-colors shadow-sm w-full sm:w-auto" data-id="element-1345" data-mp="2tt1gr9ofrpx1">
                Contact Us
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1346" data-mp="gl0gr09xcjvj" />
      <MobileStickyBar data-id="element-1347" data-mp="ldjubx8m3f0c" />
    </div>;
}